import { graphql } from '@/generated/gql';

export const SAVE_DEMAND_REQUEST_MUTATION = graphql(/* GraphQL */ `
  mutation SaveDemandRequest($id: UUID!, $data: TsrctDemandRequestInput!) {
    tesseract {
      demand(id: $id) {
        demandRequest {
          update(data: $data) {
            id
          }
        }
      }
    }
  }
`);
